import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const LayoutCtx = React.createContext({});
export const useLayout = () => React.useContext(LayoutCtx);
export const LayoutProvider = ({ children, value }) => (_jsx(LayoutCtx.Provider, { value: value, children: children }));
//# sourceMappingURL=LayoutProvider.js.map